<div class="casino-wallet-empty">
	<button class="modal-close" (click)="dismiss()">
		<ion-icon name="close-outline"></ion-icon>
	</button>

	<div class="wallet-icon">
		<ion-icon name="wallet-outline"></ion-icon>
	</div>

	<h2>{{ 'Casino wallet is empty' | translate }}</h2>
	<p>
		{{ 'Tap available to bet balance to transfer the funds or go to transfer wallet page.' | translate }}
	</p>

	<div class="actions">
		<ion-button expand="block" class="transfer-wallet-button" (click)="openTransferWallet()">
			{{ 'Transfer Wallet' | translate }}
		</ion-button>
		<ion-button expand="block" fill="clear" class="continue-casino-button" (click)="continueToCasino()">
			{{ 'Continue to Casino' | translate }}
		</ion-button>
	</div>
</div>
